import { Box, Stack, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { useContext, useState } from "react";
import { DashboardContext } from "../../../contexts/DashboardContext";
import { scrollbarStyle } from "../../../shared/dashboard";
import DashboardStatusMenu from "../../molecules/dashboard-menus/DashboardStatusMenu";
import Commentary from "../../molecules/dashboard-notes/Commentary";
import CustomFields from "../../molecules/dashboard-props/CustomFields";
import DealOwner from "../../molecules/dashboard-props/DealOwner";
import DeckLink from "../../molecules/dashboard-props/DeckLink";
import SavedLinks from "../../molecules/dashboard-props/SavedLinks";
import DescriptionQuery from "../../molecules/dashboard-queries/DescriptionQuery";
import EmailSummaryQuery from "../../molecules/dashboard-queries/EmailSummaryQuery";
import FoundedQuery from "../../molecules/dashboard-queries/FoundedQuery";
import LocationQuery from "../../molecules/dashboard-queries/LocationQuery";
import TagsQuery from "../../molecules/dashboard-queries/TagsQuery";
import UrlQuery from "../../molecules/dashboard-queries/UrlQuery";

const useStyles = makeStyles((theme) => ({
    queriesContainer: {
        marginBottom: 24,
        overflowX: 'hidden',
        position: 'relative',
    },
    masonryElement: {
        width: '100%',
        height: 'auto',
        overflow: 'hidden',
        paddingTop: 16,
        paddingBottom: 16,
        borderRadius: 16,
        background: 'white',
        transition: 'all 0.5s ease',
    },
    title: {
        fontFamily: 'Poppins',
        fontSize: '1.2rem',
        fontWeight: 'bold',
        color: '#666666',
    },
}));

const DashboardQueries: React.FC<{}> = () => {
    const classes = useStyles();
    const { isPublicView } = useContext(DashboardContext);
    const { dashboard, isShared } = useContext(DashboardContext);
    const [ctxCount, setCtxCount] = useState<number>(0);
    const [hasCommentary, setHasCommentary] = useState<boolean>(false);

    return (<>
        <Box className={classes.queriesContainer}>
            <Stack direction="row" className={classes.masonryElement}>
                <Stack direction="column" spacing={1} width="25%">
                    <DescriptionQuery />
                    <Stack spacing={1} px={2} width="100%">
                        <UrlQuery queryTitle="Website" />
                        <UrlQuery queryTitle="LinkedIn" />
                        <SavedLinks />
                        <DeckLink dashboard={dashboard!} />
                    </Stack>
                </Stack>
                <Box width={!dashboard?.customFields?.length ? "5%" : '0%'} />
                <Stack direction="column" spacing={2} width="16%">
                    <Stack px={3} width="100%" minHeight={80}>
                        <DashboardStatusMenu dashboard={dashboard!} readOnly={isPublicView} withTitle />
                    </Stack>
                    <Stack px={3} width="100%" minHeight={100}>
                        <DealOwner dashboard={dashboard!} />
                    </Stack>
                    <Stack px={1} width="100%" minHeight={100}>
                        {/* <HeadcountQuery /> */}
                        <LocationQuery />
                    </Stack>
                    <Stack px={1} width="100%" minHeight={80}>
                        <FoundedQuery />
                    </Stack>
                </Stack>
                <Box width={!dashboard?.customFields?.length ? "5%" : '0%'} />
                <Stack direction="column" spacing={2} width="21%">
                    <Stack px={2} width="100%">
                        <TagsQuery />
                    </Stack>
                </Stack>
                <Box width={!dashboard?.customFields?.length ? "5%" : '0%'} />
                <Stack direction="column" spacing={2} width={dashboard?.customFields?.length ? "16%" : '0%'}
                    sx={{ height: 408, overflowY: 'auto', ...scrollbarStyle }}>
                    <Stack px={1} width="100%">
                        <CustomFields />
                    </Stack>
                </Stack>
                <Stack direction="column" width="22%">
                    <Stack spacing={2} px={2} width="100%">
                        <Typography className={classes.title}> {'Context'} </Typography>
                        {!ctxCount && (
                            <Typography fontFamily="Inter" color="#999999">
                                {'No context or commentary provided.'}
                            </Typography>
                        )}
                    </Stack>
                    <Stack p={hasCommentary ? 2 : 0} width="100%">
                        <Commentary onHasCommentary={(state) => {
                            setCtxCount(prev => prev + +state);
                            setHasCommentary(state);
                        }} />
                    </Stack>
                    <Stack p={2} width="100%" display={isShared ? 'none' : 'flex'}>
                        <EmailSummaryQuery onHasSummary={(state) => setCtxCount(prev => prev + +state)} />
                    </Stack>
                </Stack>
            </Stack>
        </Box>
    </>);
}

export default DashboardQueries;
